import { gql } from '@lcs/shared/api';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const SavePromptMutation = gql`
   mutation SavePrompt($prompt: PromptInput!) {
      prompt: savePrompt(prompt: $prompt) {
         promptId
         name
         typeId
         isActive
         accountId
         fileId
         dontDeleteFileOnUpdate
         copyMohFile
         file {
            fileId
            fileName
            fileToken
            promptType
         }
         isReusable
      }
   }
`;
